
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lJSys", function(module, exports) {

$parcel$export(module.exports, "startApps", () => $fdbe47ab5150c3cb$export$70b2da662f343bad);

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

const $fdbe47ab5150c3cb$export$70b2da662f343bad = ()=>{
    const isGlobalSidebarEnabled = (0, $6rW04.default)('ajs-global-sidebar-enabled') === 'true';
    if (isGlobalSidebarEnabled && !(0, $1ybV0.ff)('deprecate-legacy-jira-quick-filters-package_jee7r')) (parcelRequire("deu4t"));
};

});
parcelRegister("deu4t", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1RdGZ")
]).then(()=>parcelRequire('6FSht'));

});



//# sourceMappingURL=async-rapid-board-apps.f368828e.js.map
